
// This source is part of the Akeria  and is
// copyrighted by Uniphore system software limited.

// All rights reserved.  No part of this work may be reproduced, stored in a
// retrieval system, adopted or transmitted in any form or by any means,
// electronic, mechanical, photographic, graphic, optic recording or otherwise,
// translated in any language or computer language, without the prior written
// permission of  Uniphore system software limited.

// Uniphore system software limited.
// Vaishnavi Silicon Terrace, B- Block, 
// 3rd & 4th floor, Hosur Rd, 
// Adugodi, Bengaluru, Karnataka 560095

// India

// Copyright 2019 Uniphore system software limited.

// Modification History

// Date            Version          Author                            Description
// ----------     -----------      ---------------                   ----------------------------------------
// 26 11 2019      1                Pappuraj                           confirmregiter page Developed
// 30 11 2019      1.1              Pappuraj                           Bug fixed

import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { UsernameValidator } from 'src/app/validation/password.validator';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-confirmregister',
  templateUrl: './confirmregister.component.html',
  styleUrls: ['./confirmregister.component.scss'],
})
export class ConfirmRegisterComponent implements OnInit {
  languageConext: any;
  context: any;
  headerTitle: any;
  currentpath;
  context2: any;
  userId: any;
  newpwd: any;
  retypepwd: any;
  formsubmitted: any = false;
  passwordmismatch: boolean = false;
  userIDvalid: any;
  public confirmForm: FormGroup;
  constructor(public formBuilder: FormBuilder, public _sanitizer: DomSanitizer, private router: Router, public platform: Platform, public cmndeclaration: CommonDeclarationService, public cmndef: CommonDefinitionService, public api: RestapiService) {
    this.currentpath = this.router.url;
    this.userIDvalid = false;
    if (this.cmndeclaration.LanguageJson) {
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].ExistingCustomer;
      this.context2 = this.cmndeclaration.LanguageJson['pages'][0].confmreg;
    }
    else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].ExistingCustomer;
      this.context2 = this.cmndeclaration.LanguageJson['pages'][0].confmreg;
      console.log(this.languageConext)
    }
    this.headerTitle = this.context2.heading.text;
    console.log(this.headerTitle);


    this.confirmForm = formBuilder.group({
      userId: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(20),
        Validators.minLength(8),
      ])],
      newpwd: ['', Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20),
        UsernameValidator.validUsername,
      ])],
      retypepwd: ['', Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20),
        UsernameValidator.validUsername,
      ])],
    });

  }


  ngOnInit() {

  }
  retypepassword(ev) {

    if (ev.detail.value.length == 0) {
      this.passwordmismatch = false;
    }
    else {
      this.passwordmismatch = true
    }
  }
  showinfo(msg) {
    this.cmndef.presentAlert("", msg, "info");
  }
  confirmreg() {
    console.log(this.confirmForm.valid)
    if (this.confirmForm.valid && this.userIDvalid == false) {
      var dataObj = this.cmndef.preRegisterData;
      dataObj.userType2.password = this.newpwd;
      dataObj.userType2.userId = this.userId;
      dataObj.requestType = "REGISTER";
      this.api.postapi("userRegistration", dataObj).then(response => {
        localStorage.removeItem("user");
        localStorage.removeItem("dobdate");
        localStorage.removeItem("logined");
        localStorage.removeItem("role");
        localStorage.removeItem("dob");
        localStorage.removeItem("state");
        this.cmndeclaration.ChatFullHistory=[];
        this.cmndeclaration.ChatfullList =[];
        this.cmndeclaration.capsuleList = [];
        this.cmndef.presentAlert("", response['message'], "registersuccess");
        localStorage.removeItem("logout");
        localStorage.removeItem("logout");
        localStorage.removeItem("uniqueId");
        localStorage.removeItem("userChatSessionId");
        localStorage.removeItem("userSessionID");
        localStorage.removeItem('nothanks');
        localStorage.removeItem('banner');
        localStorage.removeItem("voiceenable");
        this.cmndeclaration.deleteProcess("profile");
        this.cmndeclaration.deletefile();
      }, err => {
      }
      )
    }
    else {
      console.log(" not valid");
    }
  }


  validatefun(event, flag) {
    if (flag == 'userId') {
      this.userId = this.userId.replace(/[^A-Za-z0-9!@#$%^&*()-+_.,']/g, '');
    }
  }

  async validateUserId() {
    let res: any;
    let req: any;
    if (!this.confirmForm.get("userId").invalid) {
      await this.cmndef.loaderstart();
      req = {
        "userId": this.userId
      }
      await this.api.postapi("validateUserid", req).then(async data => {
        console.log(data);
        this.userIDvalid = false;
        await this.cmndef.loaderend();
      }, async  err => {
        console.log(err);
        this.userIDvalid = true;
        await this.cmndef.loaderend();
      })
    }
  }


}
